/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['ن', 'ظ', 'ص', 'ب.ظ.', 'ش', 'ش'],
    ['نیمه‌شب', 'ظهر', 'صبح', 'بعد از چاشت', 'شام', 'شب'],
  ],
  [
    ['ن', 'ظ', 'ص', 'بعد از چاشت', 'شام', 'ش'],
    ['نیمه‌شب', 'ظ', 'صبح', 'بعد از چاشت', 'شام', 'شب'],
    ['نیمه‌شب', 'ظهر', 'صبح', 'بعد از چاشت', 'شام', 'شب']
  ],
  [
    '00:00', '12:00', ['04:00', '12:00'], ['12:00', '17:00'], ['17:00', '19:00'],
    ['19:00', '04:00']
  ]
];
